/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { organizationUserSessionIssuersGetAuthenticationHostImpact } from "../funcs/organizationUserSessionIssuersGetAuthenticationHostImpact.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { UserSessionIssuerAuthenticationHostImpact } from "../models/components/usersessionissuerauthenticationhostimpact.js";
import {
  GetOrganizationUserSessionIssuerAuthenticationHostImpactRequest,
  GetOrganizationUserSessionIssuerAuthenticationHostImpactSecurity,
} from "../models/operations/getorganizationusersessionissuerauthenticationhostimpact.js";
import { unwrapAsync } from "../types/fp.js";
export type OrganizationUserSessionIssuerAuthenticationHostImpactQueryData =
  UserSessionIssuerAuthenticationHostImpact;

export function prefetchOrganizationUserSessionIssuerAuthenticationHostImpact(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetOrganizationUserSessionIssuerAuthenticationHostImpactRequest,
  security?:
    | GetOrganizationUserSessionIssuerAuthenticationHostImpactSecurity
    | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildOrganizationUserSessionIssuerAuthenticationHostImpactQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildOrganizationUserSessionIssuerAuthenticationHostImpactQuery(
  client$: GramCore,
  request: GetOrganizationUserSessionIssuerAuthenticationHostImpactRequest,
  security?:
    | GetOrganizationUserSessionIssuerAuthenticationHostImpactSecurity
    | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<OrganizationUserSessionIssuerAuthenticationHostImpactQueryData>;
} {
  return {
    queryKey: queryKeyOrganizationUserSessionIssuerAuthenticationHostImpact({
      id: request.id,
      useAuthenticationHost: request.useAuthenticationHost,
      gramSession: request.gramSession,
    }),
    queryFn:
      async function organizationUserSessionIssuerAuthenticationHostImpactQueryFn(
        ctx,
      ): Promise<
        OrganizationUserSessionIssuerAuthenticationHostImpactQueryData
      > {
        const sig = combineSignals(
          ctx.signal,
          options?.signal,
          options?.fetchOptions?.signal,
        );
        const mergedOptions = {
          ...options?.fetchOptions,
          ...options,
          signal: sig,
        };

        return unwrapAsync(
          organizationUserSessionIssuersGetAuthenticationHostImpact(
            client$,
            request,
            security,
            mergedOptions,
          ),
        );
      },
  };
}

export function queryKeyOrganizationUserSessionIssuerAuthenticationHostImpact(
  parameters: {
    id: string;
    useAuthenticationHost: boolean;
    gramSession?: string | undefined;
  },
): QueryKey {
  return [
    "@gram/client",
    "organizationUserSessionIssuers",
    "getAuthenticationHostImpact",
    parameters,
  ];
}
